import classNames from 'classnames'

import Text from '../../Text'

import { getPageList } from './TablePaginationPages.utils'

import * as styles from './TablePaginationPages.module.css'

function TablePaginationPages({
  className = styles.TablePaginationPages,
  disabled,
  getPaginationPageList = getPageList,
  isMobileScreenSize,
  value,
  onChange,
}) {
  const { page: currentPage, pageCount } = value

  const pages =
    Number.isFinite(currentPage) && pageCount
      ? getPaginationPageList({
          currentPage,
          isMobileScreenSize,
          pageCount,
        })
      : null

  function getHandleClick(page) {
    return () => {
      if (Number.isFinite(page) && page !== value.page && !disabled) {
        onChange({ ...value, page })
      }
    }
  }

  return pages ? (
    <div
      className={classNames(className, {
        [styles.mobile]: isMobileScreenSize,
      })}
    >
      {pages.map(page => {
        const pageClassName = classNames(styles.page, {
          [styles.active]: page === currentPage,
          [styles.hovered]: isFinite(page),
        })

        return (
          <Text
            isSecondary
            className={pageClassName}
            disabled={disabled}
            key={page}
            onClick={getHandleClick(parseInt(page))}
          >
            {isFinite(page) ? page : '...'}
          </Text>
        )
      })}
    </div>
  ) : null
}

export default TablePaginationPages
